import React, { Component } from 'react';
import DropzoneComponent from 'react-dropzone-component';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from '!isomorphic-style-loader!css-loader!./filepicker.css';
import cx from 'classnames';
import { toastr } from 'react-redux-toastr';
import { change } from 'redux-form';
import { api } from '../../../config';

// The banner form mounts one dropzone per language, so the field to write to
// comes from the redux-form input instead of a fixed name.
const fieldNameOf = (props) => (props.input && props.input.name) || 'imageUrl';

export class ImageDropzone extends Component {

    constructor(props) {
        super(props)

        this.addedfile = this.addedfile.bind(this);
        this.success = this.success.bind(this);
        this.dropzone = null;
        this.container = null;
        // Dropzone resolves hiddenInputContainer through document.querySelector,
        // so each instance needs its own selector: with a shared one every
        // dropzone on the page would drop its input into the first container.
        this.inputContainerClass = `dzInput_${fieldNameOf(props).replace(/\W/g, '_')}`;
    }

    componentDidMount() {
        this.styleHiddenInput();
    }

    componentDidUpdate() {
        this.styleHiddenInput();
    }

    // Dropzone's own input is invisible and zero-sized; stretch it over the
    // container so the whole box stays clickable.
    styleHiddenInput() {
        const hiddenInput = this.container && this.container.querySelector('.dz-hidden-input');
        if (!hiddenInput) return;
        hiddenInput.style.visibility = 'visible';
        hiddenInput.style.opacity = '0';
        hiddenInput.style.height = '100%';
        hiddenInput.style.width = '100%';
        hiddenInput.style.cursor = 'pointer';
    }

    async success(file, fromServer) {
        const { change } = this.props;

        const fileName = fromServer.fileName;

        await change("ManageBannerForm", fieldNameOf(this.props), fileName);
    }

    addedfile(file, fromServer) {
        console.log('[ImageDropzone] this:', this);
        const { startProfilePhotoLoader, stopProfilePhotoLoader, maxUploadSize, placementHeight, placementWidth } = this.props;
        console.log('[ImageDropzone] addedfile called', file);
        console.log('[ImageDropzone] Props:', this.props);
        let fileFormates = [
            'application/sql',
            'application/pdf',
            'application/vnd.oasis.opendocument.presentation',
            'text/csv',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/epub+zip',
            'application/zip',
            'text/plain',
            'application/rtf',
            'application/vnd.oasis.opendocument.text',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.oasis.opendocument.spreadsheet',
            'text/tab-separated-values',
            'text/calendar',
            'video/webm'
        ];

        if (file && file.size > (1024 * 1024 * parseInt(maxUploadSize))) {
            toastr.error('Maximum upload size Exceeded! ', 'Try with smallest size image');
            this.dropzone.removeFile(file);
        } 

        if (fileFormates.indexOf(file && file.type) > 0) {
            setTimeout(() => {
                if (file && file.accepted === false) {
                    toastr.error('Error!', 'You are trying to upload invalid image file. Please upload PNG, JPG & JPEG format image file.');
                    this.dropzone.removeFile(file.name);
                }
            }, 1000)
        }

        if (file && file.accepted === false) {
            setTimeout(() => {
                if (file && file.accepted === false) {
                    toastr.error('Error!', 'You are trying to upload invalid image file. Please upload PNG, JPG & JPEG format image file.');
                    this.dropzone.removeFile(file.name);
                }
            }, 1000)
        }

        const validateImageDimensions = (file, expectedWidth, expectedHeight) => {
            return new Promise((resolve, reject) => {
                const img = new window.Image();
                img.onload = function () {
                    console.log('[ImageDropzone] Loaded image:', img.width, img.height, 'Expected:', expectedWidth, expectedHeight);
                    const imgRatio = img.width / img.height
                    const expectedRatio = expectedWidth / expectedHeight
                    console.log("IMAGERATIO:" ,Math.abs(imgRatio - expectedRatio))
                    const TOLERANCE = 0.05
                    if (Math.abs(imgRatio - expectedRatio) > TOLERANCE) {
                        reject(new Error(`Image dimensions must be ${expectedWidth}:${expectedHeight}`));
                    } else {
                        resolve();
                    }
                };
                img.onerror = function () {
                    console.log('[ImageDropzone] Error loading image for dimension check');
                    reject(new Error('Could not read image dimensions.'));
                };
                img.src = URL.createObjectURL(file);
                console.log('[ImageDropzone] Checking image dimensions for', file.name, 'with expected', expectedWidth, expectedHeight);
            });
        };
        if (placementWidth && placementHeight) {
            const widthNum = Number(placementWidth);
            const heightNum = Number(placementHeight);
            console.log('[ImageDropzone] Will validate image dimensions:', widthNum, heightNum, file);
            validateImageDimensions(file, widthNum, heightNum)
                .then(() => {
                    console.log('[ImageDropzone] Image dimension valid');
                    // valid, do nothing
                })
                .catch((err) => {
                    console.log('[ImageDropzone] Image dimension invalid:', err.message);
                    toastr.error('Error!', err.message);
                    this.dropzone.removeFile(file);
                });
        } else {
            console.log('[ImageDropzone] Skipping dimension validation, placementWidth or placementHeight missing:', placementWidth, placementHeight);
        }

        console.log("[PLACEMENTHEIGT]", placementWidth)

        if (file && file.accepted === true) {
            // Validate image dimensions
            
        }
    }

    render() {
        const { defaultMessage, className, subTextClass, subText, maxUploadSize } = this.props;
        const apiEndpoint = api && api.apiEndpoint;


        const djsConfig = {
            dictDefaultMessage: '',
            addRemoveLinks: false,
            uploadMultiple: false,
            maxFilesize: parseInt(maxUploadSize),
            acceptedFiles: 'image/jpeg,image/png, image/svg+xml, image/jpg',
            dictMaxFilesExceeded: 'Remove the existing image and try upload again',
            previewsContainer: false,
            hiddenInputContainer: `.${this.inputContainerClass}`,
        };

        var componentConfig = {
            iconFiletypes: ['.jpg', '.png', '.svg'],
            multiple: false,
            showFiletypeIcon: false,
            postUrl: apiEndpoint + '/uploadBannerImage'
        };

        const eventHandlers = {
            init: dz => this.dropzone = dz,
            success: (...args) => this.success(...args),
            addedfile: (...args) => this.addedfile(...args)
        };


        return (
            <div className={cx('listPhotoContainer')} ref={node => { this.container = node; }}>
                <div className={cx('dzInputContainer', this.inputContainerClass, className)}>
                    <DropzoneComponent
                        config={componentConfig}
                        eventHandlers={eventHandlers}
                        djsConfig={djsConfig}
                    >
                        {defaultMessage}
                    </DropzoneComponent>
                </div>
                <p className={cx(subTextClass, 'droupText')}>
                    {subText}
                </p>
            </div>

        )
    }
}

const mapState = state => ({
    maxUploadSize: state.siteSettings.data.maxUploadSize
});

const mapDispatch = { change };

export default withStyles(s)(connect(mapState, mapDispatch)(ImageDropzone));
